.productCardImage {
  aspect-ratio: 1;
}

.productCardImage img {
  cursor: pointer;
  border-radius: var(--card-border-radius);
}

.productCardImage div {
  cursor: pointer;
}

.productLink {
  text-decoration: none;
}

.imageLink {
  width: 100%;
}

/* Mid-grid placement card variant */
.productCardPlacement {
  background-color: var(--colors-grays-white);
  border-radius: var(--card-border-radius);
}

.productCardPlacement .productCardImage {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.productCardPlacement .productCardImage img {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.productCardPlacement .priceAndAddToCartContainer {
  padding: 0 8px 8px;
}

.cardBorder {
  border: 1px solid var(--colors-grays-light);
  border-radius: var(--border-radius-lg);
  padding: 12px;
}

.cardBorder .productCardImage {
  border: 1px solid var(--colors-grays-ultralight);
}

.cardBorder.productCardPlacement .productCardImage,
.cardBorder.productCardPlacement .productCardImage img {
  border-radius: var(--card-border-radius);
}

@media (--reefer-media-tablet-min) {
  .cardBorder_small {
    padding: 12px;
  }

  .cardBorder_medium {
    padding: 16px;
  }

  .cardBorder_large {
    padding: 20px;
  }
}
